/**
 * @class ProductCard
 * @description Product card class
 * @extends HTMLElement
 */
class ProductCard extends HTMLElement {
  constructor() {
    super();

    // Selectors
    this.productWishlist = this.querySelector(".iWishAddColl");
    this.productUrls = this.querySelectorAll("[data-product-href]");
    this.productTitles = this.querySelectorAll("[data-product-title]");
    this.productPrices = this.querySelectorAll("[data-product-price]");
    this.productCompareAtPrices = this.querySelectorAll(
      "[data-product-compare-at-price]"
    );
    this.productFeaturedImage = this.querySelector(
      "[data-product-featured-image]"
    );
    this.productGroupButtons = this.querySelectorAll("[data-product-group]");

    // Loader for variants on the collection (when the product card is using the parameter with_js = true)
    this.productGroupLoader = this.querySelector("[data-product-group-loader]");

    if (this.productGroupButtons.length > 0) this.addEvents();
  }

  /**
   * @method addEvents
   * @description Looks for buttons and attach EventListeners
   */
  addEvents() {
    this.productGroupButtons?.forEach((button) => {
      if (button.dataset.infoOnCard === "true") {
        button.addEventListener("click", (event) =>
          this.handleProductGroupSwitch(event)
        );
        button.addEventListener("mouseenter", (event) =>
          this.handleProductGroupSwitch(event)
        );
      } else {
        if (button.dataset.url) {
          button.addEventListener("click", () => {
            window.location.href = button.dataset.url;
          });
        }
      }
    });
  }

  /**
   * @method handleProductGroupSwitch
   * @param {Object} event
   */
  async handleProductGroupSwitch(event) {
    // Get data from attribute
    const options = parseJson(event.currentTarget.dataset.options);

    // Guard
    if (!options) return;

    // Lock and update button state
    this.productGroupButtons?.forEach((button) => {
      button.setAttribute("disabled", true);
      button.classList.remove("product-from-same-group__button--active");
    });

    const quickShopOptions = this.querySelectorAll("[data-quick-shop-option]");
    quickShopOptions?.forEach((option) =>
      option.setAttribute("disabled", true)
    );

    event.currentTarget.classList.add(
      "product-from-same-group__button--active"
    );

    if (event.currentTarget) {
      const productCard = event.currentTarget.closest(".product-card");
      const productCardImage = productCard?.querySelector(
        ".product-card__image [data-product-featured-image]"
      );
      const buttonLargeImage =
        event.currentTarget.querySelector(".featured-image-container")
          ?.innerHTML || "";
      if (productCardImage && buttonLargeImage) {
        productCardImage.innerHTML = buttonLargeImage;
      }
    }

    // Hide the wish list when you change a product
    if (this.productWishlist) {
      if (this.productWishlist.dataset.product == options.productId) {
        this.productWishlist.classList.remove("hidden");
      } else {
        this.productWishlist.classList.add("hidden");
      }
    }

    // Update url, text labels and price values
    this.productUrls?.forEach((url) => (url.href = options.url));
    this.productTitles?.forEach(
      (title) => (title.innerHTML = options.title.replaceAll("`", "'"))
    );
    this.productPrices?.forEach((price) => (price.innerHTML = options.price));
    if (parseInt(options.compare_at_price_max) !== 0) {
      this.productCompareAtPrices?.forEach((compareAtPrice) => {
        compareAtPrice.innerHTML = options.compare_at_price;
        compareAtPrice.classList.remove("hidden");
      });
    } else {
      this.productCompareAtPrices?.forEach((compareAtPrice) => {
        compareAtPrice.classList.add("hidden");
      });
    }

    // Update image
    const image = this.productFeaturedImage.querySelector("img");
    const sources = this.productFeaturedImage.querySelectorAll("source");

    if (options.featured_image !== undefined) {
      image.src = options.featured_image;
      image.srcset = options.featured_image;
      image.alt = options.title.replaceAll("`", "'");
      sources.forEach((source) => {
        source.srcset = options.featured_image;
      });
    }

    // Fetch data for options
    const data = await fetch(`${options.url}/?sections=product-card-form`).then(
      (response) => response.json()
    );
    // Replace old with new variants
    this.querySelector(".quick-shop__holder").innerHTML = new DOMParser()
      .parseFromString(data["product-card-form"], "text/html")
      .querySelector("#shopify-section-product-card-form").innerHTML;
    // Unlock the group buttons so we can change / edit again
    this.productGroupButtons?.forEach((button) =>
      button.removeAttribute("disabled")
    );
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
